import React, { useState, useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import IncentiveHistoryModal from "./IncentiveHistoryModal";

const PayrollIncentive = ({
  toggleOffCanvas,
  fetchPayrollFn,
  pesonalDetail,
  item,
  setIsOffCanvasOpen,
  isOffCanvasOpen,
  paidPayment,
  setPaidPayment,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };
  const [selectedItem, setSelectedItem] = useState(null);

  const sidebarRef = useRef(null);
  const toggleOffCanvasAction = () => {
    setSelectedItem(null);
  };
  useEffect(() => {
    function handleClickOutside(event) {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
            setIsOffCanvasOpen(false);
        }
    }

    if (isOffCanvasOpen) {
        document.addEventListener("mousedown", handleClickOutside);
    } else {
        document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, [isOffCanvasOpen, setIsOffCanvasOpen]);
  return (
    <>
      <IncentiveHistoryModal
        isOffCanvasOpenAction={selectedItem !== null}
        item={selectedItem}
        staff={item}
        setIsOffCanvasOpenAction={toggleOffCanvasAction}
        toggleOffCanvasAction={toggleOffCanvasAction}
        setPaidPayment={setPaidPayment}
        fetchPayrollFn={fetchPayrollFn}
      />

      <div
        ref={sidebarRef}
        className={`fixed top-[56px] right-0 h-screen sm:w-[400px] w-full z-[99] shadow-cs bg-white payroll-sidebar shadow-lg transform transition-transform duration-300 ${
          isOffCanvasOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="relative w-full h-full">
          <div className="flex justify-between items-center border-gray-200 p-4 border-b">
            <h2 className="font-semibold text-[#000] text-[18px]">
              {pesonalDetail?.name}
            </h2>
            <button className="text-[black]" onClick={setIsOffCanvasOpen}>
              <CloseIcon />
            </button>
          </div>
          <div className="relative z-[1] bg-red mb-[10px] p-[10px] pb-[20px] w-full max-w-md h-[82%] overflow-y-scroll">
            <div className="flex justify-between items-center bg-[#e5e7eb96] mb-[10px] p-[10px] pr-[42px] w-full">
              <p className="font-normal text-muted-foreground text-sm">
                Incentives
              </p>
              <p className="font-normal text-muted-foreground text-sm">
                ₹{" "}
                {pesonalDetail?.staffDetails?.SalaryDetails[0]?.Incentive?.reduce(
                  (total, current) => total + (Number(current.amount) || 0),
                  0
                )?.toLocaleString("en-IN", { maximumFractionDigits: 2 }) ??
                  "0.00"}{" "}
              </p>
            </div>

            {item?.staffDetails?.SalaryDetails[0]?.Incentive?.map((staff) => {
              return (
                <Link
                  onClick={() => {
                    setSelectedItem(staff);
                  }}
                  className="flex justify-between items-center hover:bg-[#e5e7eb96] px-[10px] py-[10px] pb-[10px] border-b transition-all"
                >
                  <div>
                    <p className="font-light text-muted-foreground text-sm">
                      {new Date(staff?.date).toDateString()}
                    </p>
                    {/* <p className="font-light text-[12px] text-muted-foreground">
                    {staff?.type}
                  </p> */}
                  </div>
                  <div className="flex gap-[10px]">
                    <p className="font-light text-muted-foreground text-sm">
                      ₹{staff?.amount}
                    </p>
                    <KeyboardArrowRightIcon className="bg-[#e5e7eb96] p-[3px] rounded-[40px]" />
                  </div>
                </Link>
              );
            })}

            {paidPayment?.staffDetails?.SalaryDetails[0]?.Incentive?.length ===
              0 && (
              <p className="font-light text-center text-muted-foreground text-sm">
                No Payment History Found
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollIncentive;
